import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
export function MechanismReveal() {
  return <section className="py-10 px-4 bg-navy-900 relative border-t border-white/5" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-114">
          <h2 className="text-5xl md:text-7xl font-bebas text-white mb-4" data-id="element-115">
            No es un mazo de plástico barato que se dobla
            <br className="hidden md:block" data-id="element-116" /> a la segunda noche de juego.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg text-white/80 leading-relaxed" data-id="element-117">
          <p data-id="element-118">Basta de mazos descartables que se doblan en la primera mano.</p>
          <p data-id="element-119">
            Al adquirir esta edición, recibís un{' '}
            <span className="text-gold font-semibold" data-id="element-120">
              Master-File de ultra resolución
            </span>{' '}
            para que vos mismo definas el nivel de lujo. Imprimilo en cartulina
            de alto gramaje o papel fotográfico premium; el resultado es un mazo
            físicamente superior, más pesado y vibrante que cualquier versión de
            kiosco.
          </p>
          <p data-id="element-121">
            <span className="text-white font-medium" data-id="element-122">
              ¿Lo mejor? Es eterno.
            </span>{' '}
            Si una carta se mancha con Fernet o se pierde, no comprás un mazo
            nuevo: simplemente la imprimís de nuevo. No es solo un juego, es un{' '}
            <span className="text-gold font-semibold" data-id="element-123">activo de colección</span>{' '}
            diseñado para durar mucho más que el Mundial.
          </p>
        </motion.div>

        {/* Comparison Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-12" data-id="element-124">
          <h3 className="text-3xl md:text-4xl font-bebas text-white text-center mb-8" data-id="element-125">
            Hacé las cuentas
          </h3>

          <div className="bg-navy-800 rounded-2xl p-6 md:p-8 border border-white/10 relative overflow-hidden" data-id="element-126">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-127" />

            {/* Pack Scaloneta - Pros */}
            <div className="mb-8" data-id="element-128">
              <div className="flex items-center gap-2 mb-5" data-id="element-129">
                <span className="text-gold font-bebas text-2xl tracking-wider" data-id="element-130">
                  PACK SCALONETA
                </span>
                <span className="text-xs bg-gold/20 text-gold px-2 py-0.5 rounded font-bold uppercase" data-id="element-131">
                  $22.200
                </span>
              </div>
              <div className="space-y-3" data-id="element-132">
                <div className="flex items-center gap-3" data-id="element-133">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-134" />
                  <span className="text-white/90" data-id="element-135">
                    Mazo de cartas españolas y del "UNO" incluidas
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-136">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-137" />
                  <span className="text-white/90" data-id="element-138">
                    Edición de colección ultra limitada
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-139">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-140" />
                  <span className="text-white/90" data-id="element-141">Reimpresión ilimitada</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-142">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-143" />
                  <span className="text-white/90" data-id="element-144">
                    Contador de puntos Scaloneta{' '}
                    <span className="text-xs bg-green-500/20 text-green-400 px-1.5 py-0.5 rounded font-bold uppercase ml-1" data-id="element-145">
                      GRATIS
                    </span>
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-146">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-147" />
                  <span className="text-white/90" data-id="element-148">
                    Tablero para torneos de Truco y UNO{' '}
                    <span className="text-xs bg-green-500/20 text-green-400 px-1.5 py-0.5 rounded font-bold uppercase ml-1" data-id="element-149">
                      GRATIS
                    </span>
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-150">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-151" />
                  <span className="text-white/90" data-id="element-152">
                    Perfecta para regalo o reventa
                  </span>
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-white/10 my-6" data-id="element-153" />

            {/* En el kiosco - Contras */}
            <div data-id="element-154">
              <div className="flex items-center gap-2 mb-5" data-id="element-155">
                <span className="text-white/50 font-bebas text-2xl tracking-wider" data-id="element-156">
                  EN EL KIOSCO
                </span>
              </div>
              <div className="space-y-3" data-id="element-157">
                <div className="flex items-center gap-3" data-id="element-158">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-159" />
                  <span className="text-white/60" data-id="element-160">
                    Mazo de cartas españolas:{' '}
                    <span className="text-red-400 font-semibold" data-id="element-161">
                      $15.000 pesos
                    </span>
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-162">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-163" />
                  <span className="text-white/60" data-id="element-164">
                    Mazo de cartas del "UNO":{' '}
                    <span className="text-red-400 font-semibold" data-id="element-165">
                      $25.000 pesos
                    </span>
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-166">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-167" />
                  <span className="text-white/60" data-id="element-168">
                    Si se marcan o pierden, tenés que comprarte otras
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-169">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-170" />
                  <span className="text-white/60" data-id="element-171">No son edición limitada</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-172">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-173" />
                  <span className="text-white/60" data-id="element-174">
                    No son el mejor regalo ni tampoco ideal para revender
                  </span>
                </div>
              </div>
              <div className="mt-4 text-right" data-id="element-175">
                <span className="text-white/30 text-sm" data-id="element-176">Total mínimo: </span>
                <span className="text-white/40 font-bebas text-xl line-through decoration-red-500/60 decoration-2" data-id="element-177">
                  $40.000+
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}